import { atom } from "recoil";

const qrcodeShareAtom = atom({
  key: "qrcodeShareState",
  default: false,
});

export default qrcodeShareAtom;
